import React from 'react';
import DateField from '../formFields/DateField'
import { mirrorData } from '../utils/appUtils';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from "redux-form";

interface ReduxFormDateFieldProps {
  disabled?: boolean,
  input: WrappedFieldInputProps,
  meta: WrappedFieldMetaProps,
  label?: string,
  onChangeRTRDateRange?: (name: string, value: string) => void,
  placeholder: string,
  maxDate?: Date,
  minDate?: Date,
  required?: boolean,
  errorMessage?: string,
  setErrMsgPresent?: (value: boolean) => void,
  onChange?: (value: Date | undefined, fieldName: string) => void,
  onBlur?: (value: string | undefined, name: string | undefined, event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
}

/**
 * to be wrapped with redux-form Field component
 * @deprecated redux-form needs to be phased out
 */
export default function ReduxFormDateField(props: ReduxFormDateFieldProps) {
  const {
    disabled,
    input,
    meta,
    label,
    onChangeRTRDateRange,
    placeholder,
    maxDate,
    minDate,
    required,
    errorMessage,
    setErrMsgPresent,
    onChange,
    onBlur
  } = props;

  const customOnBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    mirrorData(input.name ?? "", input.value)
    onBlur && onBlur(input.value?.toString(), input.name, event)
  }

  // do not display warning if the field has not been touched or if it's currently being edited
  let error = errorMessage || ""
  if (meta.touched && !meta.active) {
    if (meta.valid) {
    } else {
      error = meta.error
    }
  }

  if(error && setErrMsgPresent) {
    setErrMsgPresent(true)
  }
  
  return (
    <DateField 
      label={label}
      placeholder={placeholder}
      maxDate={maxDate}
      minDate={minDate}
      required={required}
      errMsg={error}
      onChange={input.onChange}
      value={input.value}
      name={input.name}
      disabled={disabled}
      onChangeVal={(date, name) => onChange?.(date, name ?? "")}
      onBlur={customOnBlur}
      onChangeRTRDateRange={(name, value) => onChangeRTRDateRange?.(name ?? "", value)}
    />
  );
}